// Register.js
import React from 'react';
import Form from './Form';

function Register() {
    return <Form route="/register/" method="register" />;
}

export default Register;

